import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Progress} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {catalogTransactions, transactionStatus as status} from '../../../common/dictionaries/parameters';

class LoadProgressBar extends Component {
  constructor(props) {
    super(props);
    this.getProgress = this.getProgress.bind(this);
    this.progressTimer = null;
    this.transactionTimer = null;
  }

  componentDidMount() {
    const {listOrigin} = this.props;
    const progressInterval = listOrigin === 'japan' ? 10000 : 2500;

    this.transactionTimer = setInterval(() => {
      this.props.getTransactionStatus(catalogTransactions[listOrigin].transaction);
    }, 60000);

    this.progressTimer = setInterval(() => {
      this.props.getSavedRecords(catalogTransactions[listOrigin].transaction);
      this.forceUpdate();
    }, progressInterval);
  }

  componentWillUnmount() {
    clearInterval(this.transactionTimer);
    clearInterval(this.progressTimer);
  }

  getProgress(transactionStatus) {
    const {savedRecords} = this.props;

    switch (transactionStatus.statusCode) {
      case status.backup:
      case status.processing:
        return 10 + savedRecords;
      case status.restoring:
        return 95;
      default:
        return 0;
    }
  }

  render() {
    const {transactionStatus} = this.props;
    const progress = this.getProgress(transactionStatus);

    return (
      <Progress indicating progress percent={progress} inverted={!progress} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'backupRecords': state.partsCatalog.backupRecords,
    'savedRecords': state.partsCatalog.savedRecords,
    'listOrigin': state.partsCatalog.listOrigin,
  };
};

const {getBackupRecords, getSavedRecords} = Actions;

export default connect(mapStateToProps, {
  getBackupRecords,
  getSavedRecords,
})(LoadProgressBar);
